import { type ThemeColors } from "../lib/theme";
import { TargetBadge } from "./TargetBadge";
import type { ReactNode } from "react";

interface Target {
  id: number;
  title: string;
  description: string | null;
}

interface TargetBadgesProps {
  targets: Target[];
  isFound: (targetId: number) => boolean;
  theme: ThemeColors;
  isDark: boolean;
  renderBadgeContent?: (
    target: Target,
    isFound: boolean,
    index: number,
  ) => ReactNode;
  className?: string;
  showSeparators?: boolean;
  separatorClassName?: string;
}

export function TargetBadges({
  targets,
  isFound,
  theme,
  isDark,
  renderBadgeContent,
  className = "",
  showSeparators = false,
  separatorClassName,
}: TargetBadgesProps) {
  return (
    <div
      className={`flex flex-wrap items-center justify-center gap-1.5 ${className}`}
    >
      {targets.map((target, index) => (
        <div key={target.id} className="flex items-center">
          {showSeparators && index > 0 && (
            <span
              className={`mx-1.5 text-xs ${separatorClassName || (isDark ? "text-zinc-700" : "text-gray-300")}`}
            >
              /
            </span>
          )}
          <TargetBadge
            article={target}
            isFound={isFound(target.id)}
            theme={theme}
            isDark={isDark}
            className="text-xs py-1.5 px-2.5"
          >
            {renderBadgeContent?.(target, isFound(target.id), index)}
          </TargetBadge>
        </div>
      ))}
    </div>
  );
}
